<template>
  <Header />
  <div class="personal-info-activation-wrapper">
    <!-- col starts here -->
    <div class="container">
      <div class="row my-4">
        <div class="col-lg-5">
          <div class="bg-white py-3 px-3 rounded-4"></div>
        </div>
        <div class="col-lg-7">
          <div class="personal-info-col bg-white py-3 px-3 rounded-4">
            <div class="form-container-row-personal-info">
              <div class="green-bg">
                <img :src="CheckIcon" alt="" />
              </div>
              <h2>Kit activated</h2>

              <div class="info-row-status rounded-3">
                <div class="status-info-grid-row">
                  <div>
                    <img :src="InfoIcon" alt="" />
                  </div>
                  <div>
                    <p>
                      Ensure that the sticker attached to your specimen bag is used to
                      seal it once you have collected your sample. Without this we cannot
                      identify your sample or begin to test it.
                    </p>
                  </div>
                </div>
              </div>

              <p>
                Congratulations, The kit is now activated, and you can proceed to the
                Home, while you wait for the test results. You can expect to get your
                results in 6-8 weeks.
              </p>

              <p>
                You've opted into family networks! New family Networks results are
                released approximately every 10 days. Once your results are back from the
                lab you will be included in the next run of family networks. This means
                you won't receive your family networks result at the same time as the rest
                of your results.
              </p>

              <div class="personal-form-row">
                <button class="activate-kit-cta btn btn-primary w-100 mt-0">
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- col ends here -->
  </div>
</template>
<script setup>
import Header from "@/components/header/Header.vue";
import CheckIcon from "@/assets/check.png";
import InfoIcon from "@/assets/info.png";

import "../../styles/pages/Activation.scss";
</script>
